/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

class LocaleConfig {
  private _locale?: string | undefined;

  get locale() {
    return this._locale;
  }

  set locale(value: typeof this._locale) {
    this._locale = value;
  }

  public getMethods() {
    return {
      setLocale: (value: typeof this._locale) => {
        this.locale = value;
      },
      getLocale: () => this.locale,
    };
  }
}

const localeConfig = new LocaleConfig();

export const { setLocale: setGlobalLocale, getLocale: getGlobalLocale } =
  localeConfig.getMethods(); 